import { DNA } from '../visual-language'

export function iconStyles({ level = 'medium' }: IconStylesProps = {}) {
  return {
    display: 'inline-block',
    fill: 'currentcolor',
    maxWidth: '100%',
    position: 'relative',
    transition: 'fill 0.25s ease',
    userSelect: 'none',
    verticalAlign: 'text-bottom',

    ...levelStyles[level],
  }
}

const levelStyles = {
  xlarge: {
    width: DNA.tokens.dimension.font[900],
    height: DNA.tokens.dimension.font[900],
    minWidth: DNA.tokens.dimension.font[900],
    minHeight: DNA.tokens.dimension.font[900],
  },
  large: {
    width: DNA.tokens.dimension.font[700],
    height: DNA.tokens.dimension.font[700],
    minWidth: DNA.tokens.dimension.font[700],
    minHeight: DNA.tokens.dimension.font[700],
  },
  medium: {
    width: DNA.tokens.dimension.font[500],
    height: DNA.tokens.dimension.font[500],
    minWidth: DNA.tokens.dimension.font[500],
    minHeight: DNA.tokens.dimension.font[500],
  },
  small: {
    width: DNA.tokens.dimension.font[300],
    height: DNA.tokens.dimension.font[300],
    minWidth: DNA.tokens.dimension.font[300],
    minHeight: DNA.tokens.dimension.font[300],
  },
  xsmall: {
    width: DNA.tokens.dimension.font[100],
    height: DNA.tokens.dimension.font[100],
    minWidth: DNA.tokens.dimension.font[100],
    minHeight: DNA.tokens.dimension.font[100],
  },
}

export interface IconStylesProps {
  /** Icon size. */
  level?: keyof typeof levelStyles
}
